import { ModelEntity } from '../implementations/model.entity';
import { ICredentialsEntity, IUserProfileEntity } from './authentication.interfaces';

export class UserProfileEntity extends ModelEntity implements IUserProfileEntity {

    protected _email: string = null;
    protected _firstName: string = null;
    protected _lastName: string = null;
    protected _phoneMobile: string = null;
    protected _phonePrivate: string = null;
    protected _phoneWork: string = null;

    protected _credentials: ICredentialsEntity = null;

    constructor(initValues: Partial<IUserProfileEntity> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    public get email(): string {
        return this._email;
    }

    public set email(value: string) {
        this._email = value;
    }

    public get firstName(): string {
        return this._firstName;
    }

    public set firstName(value: string) {
        this._firstName = value;
    }

    public get lastName(): string {
        return this._lastName;
    }

    public set lastName(value: string) {
        this._lastName = value;
    }

    public get phoneMobile(): string {
        return this._phoneMobile;
    }

    public set phoneMobile(value: string) {
        this._phoneMobile = value;
    }

    public get phonePrivate(): string {
        return this._phonePrivate;
    }

    public set phonePrivate(value: string) {
        this._phonePrivate = value;
    }

    public get phoneWork(): string {
        return this._phoneWork;
    }

    public set phoneWork(value: string) {
        this._phoneWork = value;
    }

    public get credentials(): ICredentialsEntity {
        return this._credentials;
    }

    public set credentials(value: ICredentialsEntity) {
        this._credentials = value;
    }

}
